export default "__VITE_ASSET__DoFcvPU4__"